import DynamicFieldsFragment from '@linc-technologies/linced-common/models/dynamic-field/base-fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: people.BulkImportMedical.
export default class BulkImportMedical extends DynamicFieldsFragment {
  declare [Type]: 'people/bulk-import-medical';

  // personId is the existing Hero Person ID, if known / applicable.
  @attr('string', { defaultValue: '' })
  declare personId: string;
}
